import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Avatar from '@material-ui/core/Avatar';

const Thumbnail = ({ classes, image, title }) => (
  <Avatar className={classes.avatar} variant='rounded' src={image} alt={title} />
);

Thumbnail.propTypes = {
  classes: PropTypes.object.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default withStyles(() => ({
  avatar: {
    height: 63,
    width: 63,
    display: 'inline-flex',
  },
}))(withWidth()(Thumbnail));
